import { Component, Input } from '@angular/core';

import { LegalStandardBalanceData } from '../../fertilization-legal-standards.models';

@Component({
  selector: 'app-legal-standard-balance',
  templateUrl: './legal-standard-balance.component.html',
  styleUrls: ['./legal-standard-balance.component.scss'],
  standalone: false,
})
export class LegalStandardBalanceComponent {
  @Input() legalStandardBalance: LegalStandardBalanceData;

  constructor() {}
}
